(() => {
  const roots = [...document.querySelectorAll('[data-cf-material-gallery]')];
  if (!roots.length) return;

  const escapeHtml = (value) => String(value || '')
    .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;').replace(/'/g, '&#039;');

  let lightbox;
  let activeItems = [];
  let activeIndex = 0;

  function ensureLightbox() {
    if (lightbox) return lightbox;
    lightbox = document.createElement('div');
    lightbox.className = 'cf-material-gallery-lightbox';
    lightbox.hidden = true;
    lightbox.innerHTML = `
      <div class="cf-material-gallery-lightbox__dialog" role="dialog" aria-modal="true" aria-label="Material detail">
        <button type="button" class="cf-material-gallery-lightbox__close" aria-label="Close">×</button>
        <button type="button" class="cf-material-gallery-lightbox__arrow cf-material-gallery-lightbox__arrow--previous" aria-label="Previous material">‹</button>
        <div class="cf-material-gallery-lightbox__media"><img src="" alt=""></div>
        <div class="cf-material-gallery-lightbox__copy"><h2></h2><p></p></div>
        <button type="button" class="cf-material-gallery-lightbox__arrow cf-material-gallery-lightbox__arrow--next" aria-label="Next material">›</button>
      </div>`;
    document.body.appendChild(lightbox);
    lightbox.querySelector('.cf-material-gallery-lightbox__close').addEventListener('click', closeLightbox);
    lightbox.querySelector('.cf-material-gallery-lightbox__arrow--previous').addEventListener('click', () => showItem(activeIndex - 1));
    lightbox.querySelector('.cf-material-gallery-lightbox__arrow--next').addEventListener('click', () => showItem(activeIndex + 1));
    lightbox.addEventListener('click', (event) => { if (event.target === lightbox) closeLightbox(); });
    document.addEventListener('keydown', (event) => {
      if (lightbox.hidden) return;
      if (event.key === 'Escape') closeLightbox();
      if (event.key === 'ArrowLeft') showItem(activeIndex - 1);
      if (event.key === 'ArrowRight') showItem(activeIndex + 1);
    });
    return lightbox;
  }

  function showItem(index) {
    if (!activeItems.length) return;
    activeIndex = (index + activeItems.length) % activeItems.length;
    const item = activeItems[activeIndex];
    const modal = ensureLightbox();
    const image = modal.querySelector('img');
    image.src = item.image;
    image.alt = item.imageAlt || item.name || 'Material';
    modal.querySelector('h2').textContent = item.name || item.code || 'Material';
    modal.querySelector('p').textContent = item.notes || '';
    modal.hidden = false;
    document.documentElement.style.overflow = 'hidden';
    modal.querySelector('.cf-material-gallery-lightbox__close').focus();
  }

  function closeLightbox() {
    if (!lightbox) return;
    lightbox.hidden = true;
    document.documentElement.style.overflow = '';
  }

  function render(root, items) {
    const visible = (items || []).filter((item) => item.image);
    if (!visible.length) {
      root.innerHTML = '<p class="cf-material-gallery__status">Material images are being updated.</p>';
      return;
    }
    root.innerHTML = `<div class="cf-material-gallery__grid">${visible.map((item, index) => `
      <button type="button" class="cf-material-gallery__item" data-cf-material-index="${index}">
        <span class="cf-material-gallery__image"><img src="${escapeHtml(item.image)}" alt="${escapeHtml(item.imageAlt || item.name)}" loading="lazy"></span>
        <span class="cf-material-gallery__name">${escapeHtml(item.name || item.code || 'Material')}</span>
      </button>`).join('')}</div>`;
    root.querySelectorAll('[data-cf-material-index]').forEach((button) => {
      button.addEventListener('click', () => {
        activeItems = visible;
        showItem(Number(button.dataset.cfMaterialIndex));
      });
    });
  }

  const ids = [...new Set(roots.map((root) => root.dataset.cfMaterialGallery).filter(Boolean))];
  fetch(`/apps/collective-projects/materials?gallery_ids=${encodeURIComponent(ids.join(','))}`, { credentials: 'same-origin' })
    .then((response) => {
      if (!response.ok) throw new Error('Material galleries are unavailable.');
      return response.json();
    })
    .then((payload) => roots.forEach((root) => render(root, payload.galleries?.[root.dataset.cfMaterialGallery] || [])))
    .catch(() => roots.forEach((root) => {
      root.innerHTML = '<p class="cf-material-gallery__status">Material images are temporarily unavailable.</p>';
    }));
})();
